import { useSSR } from 'react-i18next';

declare const window: any;

export const TranslationSSR = ({ children }): JSX.Element => {
  useSSR(window.__initialI18nStore, window.__initialLanguage);

  return children;
};
